import * as utils from './utils';

const localDomains = ['pxn', 'dvlp', 'local', 'work', 'test'];

var isLocal = localDomains.filter(domain => utils.getDomain(window.location.href).split('.').pop() == domain);
var isDev = /^dev/.test(window.location.hostname) || window.location.hostname.replace(utils.getDomain(window.location.href), '').indexOf('dev.') != -1;

export default isLocal.length > 0 && process.env.NODE_ENV == 'development' ? 'local' : (isDev ? 'dev' : 'production');
